import { FeatureFlagType } from './types';

export class MEGroup {
  private readonly _featureFlags: FeatureFlagType[];

  constructor(featureFlags: FeatureFlagType[]) {
    this._featureFlags = featureFlags
      .slice()
      .sort((ff1, ff2) => ff1.id - ff2.id);
  }

  public getFeatureFlagByHash(hash: number): FeatureFlagType {
    let idx = Math.floor(hash * this._featureFlags.length);
    idx = Math.min(idx, this._featureFlags.length - 1);
    return this._featureFlags[idx];
  }

  get featureFlags(): FeatureFlagType[] {
    return this._featureFlags;
  }
}
